var exports = {
  "k": "x0a7806d5--550664--container",
  "z": "x0a7806d5--550664--container--gray",
};

module.exports = exports;
